const SERVICE_PATHS = {
  ACCESS_DENIED: '/access-denied',
  NOT_FOUND: '/404',
  STRIPE_CALLBACK_RN: '/stripe/mobile/stripe-callback'
}

export default SERVICE_PATHS
